// extracted by mini-css-extract-plugin
export default {"answersButtonContainer":"Answers_answersButtonContainer__ONhRQ","answersContainer":"Answers_answersContainer__HM-zY","backButton":"Answers_backButton__27Per"};